<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Vendas por Produto - Sintético
    </div>

    <v-card>  
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-switch v-model="isSaleOrder" hide-details :label="`${isSaleOrder ? 'Pedidos' : 'Vendas'}`"></v-switch>
          </v-col>
          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="cultureIds"
              label="Cultura(s)"
              :items="filtersList ? filtersList.accountContext.allCultures : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="cultureIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>
          
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="clientIds"
              label="Cliente(s)"
              :items="filtersList ? filtersList.accountContext.allCustomers : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="clientIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum cliente for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="productIds"
              label="Produto(s)"
              :items="filtersList ? filtersList.accountContext.productsInSales : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="productIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum produto for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="6" md="3">
            <v-autocomplete
              v-model="periodFilterModel"
              label="Período"
              :items="periodFilterOptions"
              item-value="key"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField
              :inputData.sync="periodFilterRangeModel"
              label="Período Customizado"
              :hasTodayDate="true"
            />
          </v-col>

          <v-col cols="6" md="2">
            <v-btn
              class="mt-3"
              @click="runFilter(false)">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="salesByProductsReportPrintTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Vendas por Produto - Sintético"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        class="mt-3"
      />
    </div>

    <div id="salesByProductsReportPrintTable">

      <v-row>
        <v-col cols="12">
          <BaseIndex
            ref="baseIndex"
            v-if="salesByProductSyntheticReport"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="salesByProductSyntheticReport.items"
            :maskFields="maskFields"
            :enableCustomFilters="false"
            :containTopToolbar="false"
            :itemsPerPage="-1"
            :disablePagination="true"
            :indexNested="true"
            :hasDefaultPageTitle="false"
          >
            <template slot="tableFooter">
              <tr class="d-none d-md-table-row"> 
                <td colspan="5" class="text-right title"><strong class="mx-3">Total:</strong></td>
                <td colspan="1" class="text-left title"><strong>{{ this.salesByProductSyntheticReport.totalValue | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Total</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.salesByProductSyntheticReport.totalValue | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      loading: false,
      loadingFilters: false,
      pageLoading: false,
      monthFilter: moment().format('YYYY-MM'),
      cultureIds: [],
      clientIds: [],
      isSaleOrder: false,
      productIds: [],
      salesByProductSyntheticReport: null,
      startDate: null,
      endDate: null,
      filtersList: null,
      tableHeaders: [
        { text: "Cód. Produto", align: "left", sortable: false, value: "code"},
        { text: "Produto", align: "left", sortable: false, value: "itemNameWithType"},
        { text: "Unidade", align: "left", sortable: false, value: "unitName"},
        { text: "Quantidade", align: "left", sortable: false, value: "quantity"},
        { text: "Valor Unit. Médio", align: "left", sortable: false, value: "unitPrice"},
        { text: "Valor Total", align: "left", sortable: false, value: "price"},
      ],
      maskFields: [
        { field: 'quantity', mask: 'number' },
        { field: 'unitPrice', mask: 'currency' },
        { field: 'price', mask: 'currency' },
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      periodFilterOptions: [
        // { "key": null, "name": "Sem filtro de data" },
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "MONTH",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadServerFilters();
  },
  mounted() {

  },
  methods: {
    loadServerFilters: function() {
      this.loadingFilters = true;
      this.$apollo
        .query({
          query: LOAD_FILTERS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.filtersList = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingFilters = false));
    },
    loadServerEntries: function(firstLoading=false) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALES_BY_PRODUCT_QUERY,
          variables: {
            cultureIds: this.cultureIds,
            clientIds: this.clientIds,
            productIds: this.productIds,
            startDate: this.startDate,
            endDate: this.endDate,
            isSaleOrder: this.isSaleOrder,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.salesByProductSyntheticReport = response.data.accountContext.salesByProductSyntheticReport;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    runFilter: function(firstLoading=false) {
      if(this.periodFilterModel == null){
        this.startDate = null;
        this.endDate = null;
      }
      else if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate   = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate   = this.periodFilterRangeModel[1];
        }
      }
      // console.log(this.startDate, this.endDate);
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
  }
};

const LOAD_FILTERS_QUERY = gql `
  {
    accountContext {
      allCultures {
        id
        name
      }
      allCustomers {
        id
        name
      }
      productsInSales {
        id
        name
      }
    }
  }
`;

const LOAD_SALES_BY_PRODUCT_QUERY = gql `
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $cultureIds: [ID!]!, $clientIds: [ID!]!, $productIds: [ID!]!, $isSaleOrder: Boolean) {
  accountContext {
    salesByProductSyntheticReport(cultureIds: $cultureIds, clientIds: $clientIds, productIds: $productIds, startDate: $startDate, endDate: $endDate, isSaleOrder: $isSaleOrder) 
  }
}
`;

</script>

<style scoped>
</style>
